import { allocationMetricOptions } from 'components/common/DrilldownReports/consts';
import { MetricOption, MetricType } from 'components/common/types/DrilldownReports.types';
import {
  CampaignPlanAllocationMetricId,
  CampaignPlanAllocationReportConfig,
} from 'components/common/types/CampaignPlan.types';

const metricTypeToCampaignPlanMetric: Record<Exclude<MetricType, MetricType.FRAMES>, CampaignPlanAllocationMetricId> = {
  [MetricType.SOT]: 'sot',
  [MetricType.IMPRESSIONS]: 'impressions',
  [MetricType.PRICE_INDEXED]: 'indexedPrice',
  [MetricType.PRICE_GROSS]: 'grossPrice',
};

export const getAllocationReportPlannedMetricOptions = (
  allocationReportConfig: CampaignPlanAllocationReportConfig | undefined,
): MetricOption[] => {
  if (!allocationReportConfig) {
    return [];
  }

  return allocationMetricOptions.filter(({ code }) => {
    if (code === MetricType.FRAMES) {
      return true;
    }

    return Boolean(allocationReportConfig[metricTypeToCampaignPlanMetric[code]]?.planned);
  });
};
